const select = 'id,name,description,type,order,processId,customListGroupId,isPublic,isActive';
const notSelectSearch = 'order,process,customListGroup,customList,type,isPublic,isActive';

export default {
  paged: {
    select,
    notSelectSearch,
    searchSelect: ['name', 'description'],
    expand: {
      customListGroup: { select: 'id,name' },
    },
    orderBy: 'order',
  },
  groups: {
    select: 'id,name,description,isActive',
    searchSelect: ['name', 'description'],
    notSelectSearch: 'customLists,isActive',
    expand: {
      customLists: { count: true },
    },
  },
  favorites: {
    select,
    notSelectSearch,
    searchSelect: ['name', 'description'],
    expand: {
      customListGroup: { select: 'id,name' },
    },
    orderBy: 'order',
  },
};
